module.exports = __webpack_public_path__ + "static/media/IMG_8339.201e5f73.JPG";